<ng-container *ngIf="hasData">
    <app-dc-pane
        *ngIf="priipsSummaryData"
        class="priipsSummary"
        [lightBackground]="true"
        [tableContainer]="true"
        [noScroll]="true"
        [loading]="loading"
        [headerDateStringRight]="priipsSummaryDataAsOfDate">
            <ng-container class="heading">PRIIPs Summary</ng-container>
            <app-dc-table
                rowHeight="auto"
                #table
                class="no-footer"
                [columns]="columns.priipsSummary"
                [rows]="priipsSummaryData"
                [messages]="messages"
            >
            </app-dc-table>
        </app-dc-pane>

        <app-dc-pane
            *ngIf="priipsSummaryData"
            class="priipsCosts"
            [lightBackground]="true"
            [tableContainer]="true"
            [noScroll]="true"
            [loading]="loading"
            [headerDateStringRight]="priipsCostsDataAsOfDate">
                <ng-container class="heading">PRIIPs Costs</ng-container>
                <app-dc-table
                    rowHeight="33"
                    #table
                    class="no-footer"
                    [columns]="columns.priipsCosts"
                    [rows]="priipsCostsData"
                    [messages]="messages">
                </app-dc-table>
        </app-dc-pane>

        <app-dc-pane
            *ngIf="priipsReturnScenariosData"
            class="priipsReturnScenarios"
            [lightBackground]="true"
            [tableContainer]="true"
            [noScroll]="true"
            [loading]="loading"
            [headerDateStringRight]="priipsReturnScenariosDataAsOfDate">
                <ng-container class="heading">PRIIPs Return Scenarios</ng-container>
                <app-dc-table
                    rowHeight="40"
                    #table
                    class="no-footer return__scenarios"
                    [columns]="columns.priipsReturnScenarios"
                    [rows]="priipsReturnScenariosData"
                    [messages]="messages"
                >
        </app-dc-table>

    </app-dc-pane>
</ng-container>
<app-analytics-report-state></app-analytics-report-state>